import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleQC() {
  const article = seoArticles.find((a) => a.slug === "kakobuy-qc-kompletny-poradnik")!;
  return <ArticleLayout article={article} />;
}